import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';

import DeleteAllProjectsCard from './DeleteAllProjectsCard';

export const DangerZoneCard = () => {
  return (
    <Card isFullWidth padding="medium" variant="fill" color="pink">
      <Card.Content>
        <Accordion id="danger-zone" isInitiallyOpen={false}>
          <Accordion.Target>Danger Zone</Accordion.Target>
          <Accordion.Body>
            <div>
              Changes in this section will have immediate, irreversible deletion effects.
            </div>
            <Flex direction="column" gap={12}>
              <DeleteAllProjectsCard />
            </Flex>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};
